import React from "react";
import {
  MenuItem,
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Container,
} from "@mui/material";
import Logo from "../../assets/images/Logo.png";
import Favorite from "../../assets/svgs/favorite-normal.svg";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuComponent from "../common/Menu/Menu";
import Profile from "../common/Menu/Profile";
import Pro from "../common/Popover/Pro";
import Buy from "../common/Popover/Buy";
import Auction from "../common/Popover/Auction";
import Categories from "../common/Popover/Categories";
import Magazines from "../common/Popover/Magazines";
import Currency from "../common/Menu/Currency";
import Language from "../common/Menu/Language";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Btn from "../common/Button/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useHistory, useLocation } from "react-router-dom";
import logo_mob from "../../assets/svgs/logo_mob.svg";
import FavoriteActive from "../../assets/images/favorite-active.png";
import SpareParts from "../common/Popover/SpareParts";
import Cart from "../common/Popover/Cart";

function Nav({ arrowBack = false, handleOpenDrawer, openDrawer }) {
  const tabMatch = useMediaQuery("(max-width:900px)");
  const mobMatch = useMediaQuery("(max-width:500px)");
  const history = useHistory();
  const location = useLocation();

  return (
    <>
      <AppBar
        sx={{
          border: "none",
          boxShadow: "none",
          display:
            (mobMatch && location.pathname.includes("/plp")) ||
            location.pathname.includes("/about") ||
            location.pathname.includes("/pro") ||
            location.pathname.includes("/sell-with-us") ||
            (mobMatch && location.pathname.includes("/contact-us")) ||
            (mobMatch && location.pathname.includes("/auction-page"))
              ? "none"
              : "block",
        }}
        color="secondary"
        position="static"
      >
        <Toolbar
          sx={{
            padding: { xs: "20px 16px", sm: "0px 35px 0px 18px" },
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
          }}
          disableGutters={true}
        >
          {arrowBack ? (
            <Box
              sx={{ display: { xs: "block", sm: "none" }, marginRight: "8px" }}
            >
              <ArrowBackIcon sx={{ color: "primary.main" }} />
            </Box>
          ) : null}
          <Box
            onClick={() => {
              history.push("/");
            }}
            sx={{
              display: {
                xs: "block",
                sm: "none",
                width: "fit-content",
                height: "32px",
                cursor: "pointer",
              },
            }}
          >
            <img
              src={logo_mob}
              alt="logo"
              width="156px"
              height="32px"
              style={{ objectFit: "cover" }}
            />
          </Box>
          <Container
            disableGutters={true}
            sx={{
              margin: "0",
              padding: "0",
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              justifyContent: { xs: "space-between", md: "auto" },
              columnGap: "24px",
              width: "auto",
              minHeight: "72px",
            }}
          >
            <Box
              sx={{
                marginRight: "24px",
                width: "169px",
                height: "40px",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("/");
              }}
            >
              <img src={Logo} alt="logo" width="169px" height="40px" />
            </Box>
            <Pro />
            <Buy />
            <Auction />
            <Box
              sx={{
                width: "1px",
                height: "20px",
                backgroundColor: "#BFBFBF",
              }}
            ></Box>
            {/* <Box
              sx={{
                width: "1px",
                height: "20px",
                backgroundColor: "#BFBFBF",
              }}
            ></Box> */}
            <Categories />
            <Magazines />
          </Container>
          <Container
            disableGutters={true}
            sx={{
              display: { xs: "flex", sm: "none" },
              alignItems: "center",
              justifyContent: "flex-end",
              margin: "0",
            }}
          >
            <img
              src={FavoriteActive}
              width="24px"
              height="24px"
              alt="favorite"
            />
            <MenuComponent
              icons={[
                <AccountCircleIcon
                  sx={{ fontSize: "24px" }}
                  htmlColor="#808080"
                />,
              ]}
              textStyle={{ color: "text.primary" }}
            >
              <MenuItem>Profile</MenuItem>
              <MenuItem>My account</MenuItem>
              <MenuItem>Logout</MenuItem>
            </MenuComponent>
          </Container>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={() => {
              handleOpenDrawer();
              console.log(openDrawer);
            }}
            sx={{
              paddingY: "0px",
              display: {
                xs: openDrawer ? "none" : "inline-flex",
                lg: "none",
              },
            }}
          >
            <MenuIcon />
          </IconButton>
          <Container
            disableGutters={true}
            sx={{
              alignItems: "center",
              display: { xs: "none", lg: "flex" },
              width: "auto",
              columnGap: "24px",
              margin: "0",
            }}
          >
            {/* <MenuComponent
              text="English"
              textVariant="subtitle2"
              buttonVariant="text"
              textStyle={{ color: "text.primary" }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              paperStyle={{
                borderRadius: "4px",
                marginTop: "10px",
              }}
              icons={[<ArrowDropDownIcon />]}
              buttonStyle={{ width: "68px", height: "20px", padding: "0px" }}
            >
              <MenuItem>Profile</MenuItem>
              <MenuItem>My account</MenuItem>
              <MenuItem>Logout</MenuItem>
            </MenuComponent> */}
            <Language />
            <Currency />
            <Btn
              typoVariant="subtitle2"
              variant="outlined"
              bgColor="#FFF"
              txColor="primary.main"
              sx={{ height: "36px", boxShadow: "none" }}
              hoverBg="primary.main"
              hoverTxColor="white"
            >
              Sell with us
            </Btn>
            <img
              src={FavoriteActive}
              width="24px"
              height="24px"
              alt="favorite"
            />
            <Profile />
          </Container>
        </Toolbar>
      </AppBar>
    </>
  );
}

export default Nav;
